"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createURL = void 0;
var browser_1 = require("@cian/config/browser");
var shared_1 = require("../../../shared");
var URI_1 = require("./URI");
function createURL(params) {
    var model = params.model, subdomain = params.subdomain, transformBodyToLegacyString = params.transformBodyToLegacyString;
    var baseUrl = (0, URI_1.getBaseUrlFromConfig)((0, browser_1.getConfig)(), model);
    var url = new URL(baseUrl);
    if (subdomain) {
        url.hostname = "".concat(subdomain, ".").concat(url.hostname);
    }
    url.pathname = (0, shared_1.mergePaths)(url.pathname, model.pathApi);
    if (model.method === 'GET' && model.parameters) {
        url.search = (0, shared_1.transformObjectToQuery)(model.parameters, transformBodyToLegacyString);
    }
    return url;
}
exports.createURL = createURL;
//# sourceMappingURL=URL.js.map